<template>
  <div class="box-filter">
    <el-form :model="ruleForm" ref="ruleForm" @submit.prevent v-on:submit.prevent>
      <div class="viewFilter">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="marketplace_manager_id" label="Gerente de Marketplace">
              <SelectSearchGerenteMarketplace :disabled="$can('2|6')" :model="ruleForm.marketplace_manager_id" :isEdit="false" @handleValue=" (x) => { ruleForm.marketplace_manager_id = x } "  />
            </el-form-item>
          </el-col>
         <el-col :span="8">
           <el-form-item prop="marketplace_id" label="Marketplace">
             <SelectSearchMarketplace :disabled="$can('2')" :canMarketplaceManager="ruleForm.marketplace_manager_id" :model="ruleForm.marketplace_id" :isEdit="false" @handleValue=" (x) => { ruleForm.marketplace_id = x } "  />
           </el-form-item>
         </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-col :xs="24" :span="15">
             <el-button  @click='searchTable(true)' type="default" size="large" style="float: right; margin-right: 20px">
              Exportar Merchants
            </el-button>
            <el-button v-if="statusClearFilter" @click='clearSearch()' type="default" size="large" style="float: right; margin-right: 20px">
              Limpar Filtros
            </el-button>

          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>

import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";
import SelectSearchGerenteMarketplace from "@/app/components/GerenteMarketplace/SelectSearchGerenteMarketplace";
import {getCity, getState} from "@/app/domains/Config/services";
import {mapGetters} from "vuex";
export default {
  name: "FilterBox",
  components: {
    SelectSearchGerenteMarketplace,
    SelectSearchMarketplace,
  },
  data () {
    return {
      loadingPage: true,
      query:`?page=${this.currentPage}`,
      cityOptions: [],
      StateOptions: [],
      ruleForm: {
        marketplace_id: null,
        marketplace_manager_id: null,
      },
      viewFilter: false,
      loadingCity: false,
    }
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    type: {
      type: Number,
      default: 0
    }
  },
  watch: {
    'ruleForm.marketplace_manager_id': function() {
      this.ruleForm.marketplace_id = null;
    }
  },
  computed: {
    ...mapGetters('Auth', ['currentUser']),
    statusClearFilter: function () {
      if (this.ruleForm.marketplace_manager_id || this.ruleForm.marketplace_id) {
        return true
      }
      return false
    }
  },
  methods: {
    clearSearch () {
      this.viewFilter = false
      this.ruleForm = {
        marketplace_manager_id: null,
        marketplace_id: null,
      }
      this.$emit('filter', `?page=${this.currentPage}`)
      this.query = '?page=${this.currentPage}';
    },
    async serchCity (query) {
      if (query.length > 2) {
        this.loadingCity = true
        try {
          let response = await getCity('?name='+query)
          this.cityOptions = response.data.data
          this.$set(this.ruleForm, 'country_code', 55)
        } catch (e) {
          this.$message({
            showClose: true,
            message: e.body.error.message,
            type: 'error'
          })
        } finally {
          this.loadingCity = false
        }
      }
    },
    async serchState (query) {
      if (query.length > 2) {
        this.loadingCity = true
        try {
          let response = await getState('?name='+query)
          this.StateOptions = response.data.data
        } catch (e) {
          this.$message({
            showClose: true,
            message: e.body.error.message,
            type: 'error'
          })
        } finally {
          this.loadingCity = false
        }
      }
    },
    searchTable (ex) {
      this.query = `?page=${this.currentPage}`;
      if (this.ruleForm.marketplace_manager_id) {
        this.query = `${this.query}&marketplace_manager_id=${this.ruleForm.marketplace_manager_id}`
      }
      if (this.ruleForm.marketplace_id) {
        this.query = `${this.query}&marketplace_id=${this.ruleForm.marketplace_id}`
      }
       if (ex) {
        this.$emit('filterExport', this.query)
      } else {
        this.$emit('filter', this.query)
      }
    },

  },
  async mounted() {
    if (this.$can('6')) {
      this.ruleForm.marketplace_manager_id = this.currentUser.marketplace_manager_id
    }
    if (this.$can('2')) {
      this.$set(this.ruleForm, 'marketplace_id', this.currentUser.marketplace_id)
      this.ruleForm.marketplace_id = this.currentUser.marketplace_id

      this.$set(this.ruleForm, 'marketplace_manager_id', this.currentUser.marketplace.marketplace_manager_id)
      this.ruleForm.marketplace_manager_id = this.currentUser.marketplace.marketplace_manager_id
    }
  }
}
</script>

<style scoped>

</style>
